module.exports = __webpack_public_path__ + "img/start2.b7ca4301.png";